module.exports = __webpack_public_path__ + "static/media/ios-cellular.241c6df6.svg";